import { useState } from "react";
import { Input } from "../ui/input";
import { Label } from "@radix-ui/react-label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "../ui/button";
import { DialogClose } from "@radix-ui/react-dialog";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axios from "axios";
import { Alert } from "../ui/alert";
import { Check } from "lucide-react";

interface ResetPasswordDialogProps {
  initialEmail: string;
}

const ResetPasswordDialog = ({ initialEmail }: ResetPasswordDialogProps) => {
  const [email, setEmail] = useState(initialEmail || "");
  const [success, setSuccess] = useState(false);

  const { mutate: envoyer, isPending } = useMutation({
    mutationFn: async () => {
      await axios.post(`${import.meta.env.VITE_API_URL}/auth/send-reset-password-email`, {
        email: email.trim().toLowerCase(),
      });
    },
    onSuccess: () => {
      setSuccess(true);
    },
    onError: (err: any) => {
      console.error(err.response?.data || err);
      toast.error(`Une erreur s'est produite`);
    },
  });

  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open) setEmail("");
      }}
    >
      <DialogTrigger className='text-sm hover:underline mt-1 font-medium'>Mot de passe oublié ?</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Mot de passe oublié</DialogTitle>
          <DialogDescription>
            Vous recevrez un e-mail avec un lien pour réinitialiser votre mot de passe.
          </DialogDescription>
        </DialogHeader>

        <div className='flex flex-col gap-6'>
          {/* Body */}
          <div className='grid w-full items-center gap-1.5'>
            <Label htmlFor='mail-reset' className='text-sm font-medium'>
              Adresse mail
            </Label>
            <Input
              id='mail-reset'
              type='email'
              value={email}
              required
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
          </div>

          {success && (
            <Alert className=' bg-green-100 text-sm'>
              Si un compte avec cette adresse existe bien, alors un email contenant un lien de changement de mot de
              passe vient de vous être envoyé. Pensez également à vérifier dans vos courriers indésirables.
            </Alert>
          )}

          <DialogFooter>
            <DialogClose asChild>
              <Button variant={"outline"}>Fermer</Button>
            </DialogClose>
            <Button icon={<Check />} loading={isPending} disabled={success} onClick={() => envoyer()}>
              Valider
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResetPasswordDialog;
